<template>
  <div>
    <div>
      <el-form :inline="true" :model="listQuery" class="demo-form-inline">
        <el-form-item label="考场名称:">
          <el-input v-model="listQuery['filter[name]']" clearable placeholder="考场名称"></el-input>

        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="medium" @click="search">查询</el-button>
          <el-button type="success" size="medium" @click="handleAdd">新增试卷</el-button>
          <el-button type="warning" size="medium" @click="handleAuto">题库组卷</el-button>
          <el-upload class="upload-demo" :action="uploadUrl2"   :headers="headers1" :show-file-list="false" :on-success="handleAvatarSuccess1" style="display:inline-block">
            <el-button type="info"  size="medium">导入试题</el-button>
          </el-upload>
          <el-button   size="medium" @click="handleDownload">模板下载</el-button>

        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column prop="id" label="序号">
      </el-table-column>
      <el-table-column prop="name" label="试卷名称" >
      </el-table-column>
      <el-table-column prop="ctime" label="创建时间" >
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="success" size="mini"  @click="handleView(scope)">预览</el-button>
<!--          <el-button type="warning" size="mini"  @click="handleEdit(scope)">编辑</el-button>-->
<!--          <el-button type="info" size="mini"  @click="handleDownload(scope)">下载</el-button>-->
          <el-button type="danger" size="mini" @click="handleDelete(scope)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- v-if="pageform.total>pageform.pageSize" -->

    <div style="text-align: right;margin-top:20px">

      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.per_page" @pagination="getData"/>

    </div>
    <el-dialog :visible.sync="dialogVisible" :title="dialogType==='edit'?'编辑考场':'新增考场'">
      <el-form :model="room" label-width="120px" label-position="left">
        <el-form-item label="名称" prop="name" required>
          <el-input v-model="room.name" placeholder="输入名称"/>
        </el-form-item>
                <el-form-item label="关联摄像机" >
                  <el-select multiple v-model="room.vcr_id" @change="selectChange" placeholder="请选择">
                    <el-option
                      v-for="item in vcrList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
        <el-form-item label="描述" >
          <el-input v-model="room.description" placeholder="描述"/>
        </el-form-item>
        <el-form-item label="地址" >
          <el-input v-model="room.address" placeholder="地址"/>
        </el-form-item>
        <el-form-item label="所在楼层" >
          <el-input v-model="room.floor" placeholder="所在楼层"/>
        </el-form-item>
        <el-form-item label="房号" >
          <el-input v-model="room.room_number" placeholder="房号"/>
        </el-form-item>
        <el-form-item label="户型" >
          <el-input v-model="room.house_type" placeholder="户型"/>
        </el-form-item>
        <el-form-item label="朝向" >
          <el-input v-model="room.orientation" placeholder="朝向"/>
        </el-form-item>
        <el-form-item label="可用面积" >
          <el-input v-model="room.proportion" placeholder="可用面积"/>
        </el-form-item>
        <el-form-item label="最大容纳人数" >
          <el-input v-model="room.max_num" placeholder="最大容纳人数"/>
        </el-form-item>
      </el-form>
      <div style="text-align:right;">
        <el-button type="danger" @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" @click="confirmSave">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
    import Pagination from '../../components/Pagination'
    export default {
        components: { Pagination },
  props: {

  },
  data() {
    return {
        room:{},
        roomList:[],
        vcrList:[],
        total:0,
        dialogType:'new',
        dialogVisible:false,
        uploadUrl2: this.GLOBAL.BASE_URL + 'api/theory/import',
        headers1: {
            Authorization: 'Bearer' + this.$cookies.get('token')
        },
        listQuery: {
            page: 1,
            per_page:20
        },
      tableData: []
    };
  },
  computed: {

  },
  created() {
    this.getData();
  },
  methods: {
      handleAvatarSuccess1(res, file) {
          if (res.code == 1) {
              this.$message.success(res.message);
              this.getData();
          } else {
              this.$message.error(res.message);
          }

      },

      selectChange(){
          this.$forceUpdate()
      },
    search() {
      this.listQuery.page = 1;
      this.getData()
    },
    // 获取全部的课程列表
    getData() {
      this.$http.getExamPaper( this.listQuery)
        .then(res => {
          this.tableData = res.data;
            this.total = res.meta.total;
        })
        .catch(err => {
          console.log(err);
        })
    },
      handleAdd() {
        this.$router.push({name:'addQuestion'})
      },
      handleAuto(){
          this.$router.push({name:'autoQuestion'})
      },
      handleEdit(scope) {
          this.dialogType = 'edit';
          this.dialogVisible = true;
          this.$http.getRoom(scope.row.id,{include:'vcr'}).then(res=>{
              const  vcrs=[];
              this.room =res.data
              this.room.vcr.forEach((i)=>{
                  vcrs.push(i.id)
              })
              this.room.vcr_id =vcrs
              delete this.room.vcr
          })
      },
      handleView(scope)
      {
         this.$router.push({name:'theoryView',query:{id:scope.row.id}})
      },
      handleDownload(scope)
      {
          window.open(this.GLOBAL.BASE_URL + "api/download-paper")
      },
      confirmSave(){
          const isEdit = this.dialogType === 'edit'
          if (isEdit) {
              this.$http.updateRoom(this.room.id, this.room).then(res => {
                  this.dialogVisible = false
                  this.$notify({
                      title: 'Success',
                      message: '操作成功！',
                      type: 'success'
                  });
                  this.getData()
              })
          } else {
              this.$http.addRoom(this.room).then(res => {
                  this.dialogVisible = false
                  this.$notify({
                      title: 'Success',
                      message: '操作成功！',
                      type: 'success'
                  })
                  this.getData()
              })
          }
      },
      handleDelete({$index, row}) {
          this.$confirm('确定要删除此条吗?', '警告', {
              confirmButtonText: '删除',
              cancelButtonText: '取消',
              type: 'warning'
          })
              .then(() => {
                  this.$http.deletePaper(row.id).then(res => {
                      this.getData()
                      this.$message({
                          type: 'success',
                          message: '删除成功!'
                      })
                  });

              })
              .catch(err => {
                  this.$message.error(err.data.message)
              })
      },
  },
};
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/page/theoryManage/examPaper.vue